/* eslint-disable*/
// 与 browserslist 对齐：旧版 Safari / iOS 需 core-js 等（须在业务代码与 adapter 之前）
import 'react-app-polyfill/stable'
// macOS Safari 11 无原生 ResizeObserver / IntersectionObserver，Ant Design / rc-* 会用到
import ResizeObserverPolyfill from 'resize-observer-polyfill'
if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
  window.ResizeObserver = ResizeObserverPolyfill
}
import 'intersection-observer'
// WebRTC polyfill - 必须在其他导入之前加载
import 'webrtc-adapter';

import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import Theme from './ThemeConfig'
import zhCN from 'antd/locale/zh_CN'
import ErrorBoundary from '@/components/ErrorBoundary'
import App from './App'
import { store } from './redux/store'
import { loadState, saveState } from '@/utils/localStorage'
import { login } from '@/utils/auth'
import * as serviceWorker from './serviceWorker'
import "antd/dist/reset.css"
// antd-mobile 全局样式（:root 变量、touch 等）；须在自定义覆盖之前加载
import 'antd-mobile/es/global'
import '@/theme/antdMobileCompat.less'

// 旧版浏览器 CSS 降级 降维
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs'

import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import 'dayjs/locale/zh-cn'
import { initVConsole } from '@/utils/initVConsole'

dayjs.locale('zh-cn')
dayjs.extend(isSameOrAfter)

// initVConsole()

const validateMessages = {
  required: "请补充 ${label}"
}

const history = createBrowserHistory()
const location = history.location

// 订阅 store 变化，保存到 localStorage
store.subscribe(() => {
  const state = store.getState()
  saveState({
    app: state.app
  })
})
// V18
const container = document.getElementById('root')
const root = createRoot(container)
const render = () => (
  root.render(
    <Provider store={store}>
      <StyleProvider
        hashPriority="high"
        transformers={[legacyLogicalPropertiesTransformer]}
      >
        <BrowserRouter>
          <ConfigProvider
            form={{ validateMessages }}
            locale={zhCN}
            theme={{
              token: Theme
            }}
          >
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ConfigProvider>
        </BrowserRouter>
      </StyleProvider>
    </Provider>
  )
)
// if (location.pathname !== '/system/login') {
//   login(null, render)
// }
render()

serviceWorker.unregister()